<template>
  <!--translate-->
  <div>
    <userTagsDialog
      v-if="canTagOnly && !isReadOnlyUser"
      :item="item"
      @reloadData="reloadDataFunc"
    />
    <template v-if="canManage && !isReadOnlyUser">
    <changePassword @triggerChangePassword="changePassword" :item="item" />
    <user-permissions
        v-bind:item="item"
    />
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="editItem(item)"
          data-cy="edit"
        >
          edit</v-icon
        >
      </template>
      <span>{{ $t("settings.editUser") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="!isSelf && canDelete">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openDeleteDialog(item)"
          data-cy="delete"
        >
          delete</v-icon
        >
      </template>
      <span>{{ $t("settings.deleteUser") }}</span>
    </v-tooltip>
    </template>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
    <passwordForm
      ref="passwordForm"
      :data="passwordForm"
      @reloadData="reloadDataFunc"
    />
  </div>
</template>

<script>
import deleteDialog from "../../_utils/dataTableHelpers/actions/deleteDialog.vue";
import passwordForm from "./passwordForm.vue";
import changePassword from "./changePassword.vue";
import UserPermissions from "@/components/tableSlotComponents/users/userPermissions.vue";
import { canManageUser, canDeleteUser, canAssignTags } from "@/utils/userAuthz";
import userTagsDialog from "./userTagsDialog.vue";
export default {
  props: ["item"],
  computed: {
    currentUser() {
      try {
        return JSON.parse(localStorage.getItem("userData"));
      } catch (e) {
        return null;
      }
    },
    canManage() {
      return canManageUser(this.currentUser, this.item);
    },
    canDelete() {
      return canDeleteUser(this.currentUser, this.item);
    },
    canTagOnly() {
      return !this.canManage && canAssignTags(this.currentUser);
    },
    isSelf() {
      const a = String(this.currentUser?._id || this.currentUser?.id || "");
      const b = String(this.item?._id || this.item?.id || "");
      return !!a && a === b;
    },
  },
  components: {
    userTagsDialog,
    UserPermissions,
    deleteDialog,
    changePassword,
    passwordForm,
  },
  data: () => ({
    userPermissionsForm: true,
    deleteDialog: {
      open: false,
      title: "",
      description: "",
    },
    passwordForm: {
      open: false,
      title: "",
      item: {},
    },
  }),
  methods: {
    changePassword(item) {
      this.passwordForm.open = true;
      this.passwordForm.title = "users.changePassword";
      this.passwordForm.method = "edit";
      //clone table item to decouple reference from table
      this.$refs.passwordForm.triggerEdit(Object.assign({}, item));
    },
    editItem(item) {
      this.$router.push({
        name: "usersForm",
        params: { id: item.id, mode: "edit" },
      });
    },
    openDeleteDialog(item) {
      this.deleteDialog.open = true;
      this.deleteDialog.description =
        this.$t("users.deleteConfirm", { name: item.name });
    },
    deleteItem(item) {
      this.$store.dispatch("deleteUser", item).then(() => {
        this.reloadDataFunc();
        this.deleteDialog.open = false;
      });
    },
    reloadDataFunc() {
      this.$emit("reloadData");
    },
  },
};
</script>
